import { combineReducers } from 'redux';
import mainReducer from '@/bit/reducers/reducers.main-reducer';
import headerReducer from '@/bit/reducers/reducers.header-reducer';
import modalsReducer from '@/bit/reducers/reducers.modals-reducer';
import smsReducer from '@/reducers/sms-reducer';
import accountReducer from '@/reducers/account-reducer';
import errorReducer from '@/reducers/error-reducer';

const rootReducers = () =>
  combineReducers({
    main: mainReducer,
    header: headerReducer,
    modals: modalsReducer,
    sms: smsReducer,
    error: errorReducer,
    account: accountReducer,
  });

export default rootReducers;
